// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + chunkId + "." + {"270":"45990a225b113e400a01","788":"45990a225b113e400a01"}[chunkId] + ".css";
};